/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { useInputState } from '@infotrack/presentacion-utilitarios/hooks';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import IBanco from 'Infotrack@Modelos/administracion/banco/entidades/banco';
import React from 'react';
import BancoCM from '../controladorModelo/bancoCM';
import { acciones, IEstadoBanco } from '../reductorBanco';
import FormularioBancoVista from '../vista/formularioBancoVista';

const estadoInicial: IBanco = {
    CodigoBanco: '',
    NombreBanco: '',
    EstadoBanco: true,
};
const bancoCM = new BancoCM();

const FormularioBancoCV: React.FunctionComponent = () => {
    const [{ estadoFormulario, tipoFormulario, entidadBanco }, dispatch] = useProveedor<IEstadoBanco>();
    const { alCambiarValor, setValor, reiniciar, valor } = useInputState<IBanco>(estadoInicial);

    React.useEffect(() => {
        if (entidadBanco && tipoFormulario !== TipoFormulario.Creacion) {
            setValor(entidadBanco);
        } else {
            reiniciar();
        }
    }, [entidadBanco]);

    const cerrarFormulario = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: null });
    };
    const confirmarCreacionEdicionBanco = () => {
        if (bancoCM.validarEntidad(valor)) {
            manejadorDialogoGlobal({
                accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
                accionConfirmar: crearEditarBanco,
                estado: true,
                mensaje: (
                    <Texto
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'alerta.confirmacionCreacion'
                                : 'alerta.confirmacionEdicion'
                        }
                    />
                ),
                mostrarCancelar: true,
                tipoDialogo: 'Advertencia',
                titulo: <Texto id="titulo.advertencia" />,
            });
        }
    };

    const crearEditarBanco = () => {
        manejadorDialogoGlobal({ estado: false });
        if (tipoFormulario === TipoFormulario.Creacion) {
            bancoCM.crearBanco(valor).then(() => {
                cerrarFormulario();
                dispatch({ type: acciones.RECARGAR_TABLA });
            });
        } else {
            bancoCM.editarBanco(valor).then(() => {
                cerrarFormulario();
                manejadorIndicadorCargaGlobal(false);
                dispatch({ type: acciones.RECARGAR_TABLA });
            });
        }
    };

    return (
        <FormularioBancoVista
            accionCrearEditar={confirmarCreacionEdicionBanco}
            cambiarInfoFomulario={alCambiarValor}
            banco={valor}
            cerrarFormulario={cerrarFormulario}
            estadoFormulario={estadoFormulario}
            tipoFormulario={tipoFormulario}
        />
    );
};

export default FormularioBancoCV;
